import { createPortal } from 'react-dom'

const ScannerBoxOverlay = () => {
  const boxWidth = 'min(90vw, 400px)'
  const boxHeight = 'min(70vw, 280px)'

  return createPortal(
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        pointerEvents: 'none',
        zIndex: 0,
      }}
    >
      {/* Top overlay */}
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100vw',
          height: `calc(50vh - (${boxHeight} / 2))`,
          background: 'rgba(0,0,0,0.25)',
        }}
      />
      {/* Bottom overlay */}
      <div
        style={{
          position: 'absolute',
          top: `calc(50vh + (${boxHeight} / 2))`,
          left: 0,
          width: '100vw',
          height: `calc(50vh - (${boxHeight} / 2))`,
          background: 'rgba(0,0,0,0.25)',
        }}
      />
      {/* Left overlay */}
      <div
        style={{
          position: 'absolute',
          top: `calc(50vh - (${boxHeight} / 2))`,
          left: 0,
          width: `calc(50vw - (${boxWidth} / 2))`,
          height: boxHeight,
          background: 'rgba(0,0,0,0.25)',
        }}
      />
      {/* Right overlay */}
      <div
        style={{
          position: 'absolute',
          top: `calc(50vh - (${boxHeight} / 2))`,
          left: `calc(50vw + (${boxWidth} / 2))`,
          width: `calc(50vw - (${boxWidth} / 2))`,
          height: boxHeight,
          background: 'rgba(0,0,0,0.25)',
        }}
      />
      {/* Scan box border */}
      <div
        style={{
          position: 'absolute',
          top: `calc(50vh - (${boxHeight} / 2))`,
          left: `calc(50vw - (${boxWidth} / 2))`,
          width: boxWidth,
          height: boxHeight,
          border: '3px solid #fff',
          borderRadius: '2px',
          boxSizing: 'border-box',
        }}
      />
    </div>,
    document.body
  )
}

export const ReceivingScannerBoxOverlay = ({
  width = '675px',
  height = '381px',
}: {
  width?: string
  height?: string
}) => {
  const boxWidth = '200px'
  const boxHeight = '150px'

  return (
    <div
      style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        width,
        height,
        pointerEvents: 'none',
        transform: 'translate(-50%, -50%)',
        zIndex: 0,
      }}
    >
      {/* Top overlay */}
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: `calc(50% - (${boxHeight} / 2))`,
          background: 'rgba(0,0,0,0.25)',
        }}
      />
      {/* Bottom overlay */}
      <div
        style={{
          position: 'absolute',
          top: `calc(50% + (${boxHeight} / 2))`,
          left: 0,
          width: '100%',
          height: `calc(50% - (${boxHeight} / 2))`,
          background: 'rgba(0,0,0,0.25)',
        }}
      />
      {/* Left overlay */}
      <div
        style={{
          position: 'absolute',
          top: `calc(50% - (${boxHeight} / 2))`,
          left: 0,
          width: `calc(50% - (${boxWidth} / 2))`,
          height: boxHeight,
          background: 'rgba(0,0,0,0.25)',
        }}
      />
      {/* Right overlay */}
      <div
        style={{
          position: 'absolute',
          top: `calc(50% - (${boxHeight} / 2))`,
          left: `calc(50% + (${boxWidth} / 2))`,
          width: `calc(50% - (${boxWidth} / 2))`,
          height: boxHeight,
          background: 'rgba(0,0,0,0.25)',
        }}
      />
      {/* Scan box border */}
      <div
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: boxWidth,
          height: boxHeight,
          border: '3px solid white',
          borderRadius: '2px',
          boxSizing: 'border-box',
          zIndex: 1,
        }}
      />
    </div>
  )
}

export default ScannerBoxOverlay
